/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import agSystem from './system/system.directive';
import agEditSystem from './system/edit-system.directive';
import agSite from './site/site.directive';
import agEditSite from './site/edit-site.directive';
import agSiloGroup from './silogroup/silo-group.directive';
import agSilo from './silo/silo.directive';
import agAeration from './aeration/aeration.directive';
import agWeatherStation from './weatherstation/weather-station.directive';
import agAerationsAdmin from './aeration/aerations-admin.directive';
import agEditAeration from './aeration/edit-aeration.directive';
import agEditWeatherStation from './weatherstation/edit-weather-station.directive';
import agEditSiteAsset from './site/edit-site-asset.directive';
import agSilosAdmin from './silo/silos-admin.directive';
import agEditSilo from './silo/edit-silo.directive';
import agAssetUnitsAdmin from './asset/asset-units-admin.directive';
import agDevice from './device/device.directive';
import agSubsys from './device/subsys.directive';
import agEditAssetDevice from './asset/edit-asset-device.directive';
import agAssetUnitWidget from './asset/asset-unit-widget.directive';
import agDevicesAdmin from './device/devices-admin.directive';
import agEditDevice from './device/edit-device.directive';
import agSetupSettingsAdmin from './setup-settings/setup-settings-admin.directive';
import agEditSetupSettings from './setup-settings/edit-setup-settings.directive';
import agEntitiesAssignment from './entity/entities-assignment.directive';

import AddTemperatureCablesController from './device/cables-wizard/add-temperature-cables.controller';
import SmsSetupWizardController from './device/sms-wizard/sms-setup-wizard.controller';

export default angular.module('agrolog.admin', [
    agSystem,
    agEditSystem,
    agSite,
    agEditSite,
    agSiloGroup,
    agSilo,
    agAeration,
    agWeatherStation,
    agAerationsAdmin,
    agEditAeration,
    agEditWeatherStation,
    agEditSiteAsset,
    agSilosAdmin,
    agEditSilo,
    agAssetUnitsAdmin,
    agDevice,
    agSubsys,
    agEditAssetDevice,
    agAssetUnitWidget,
    agDevicesAdmin,
    agEditDevice,
    agSetupSettingsAdmin,
    agEditSetupSettings,
    agEntitiesAssignment])
    .controller('AddTemperatureCablesController', AddTemperatureCablesController)
    .controller('SmsSetupWizardController', SmsSetupWizardController)
    .name;
